export enum Forms {
  AI_USAGE_FILTER_FORM = 'AI_USAGE_FILTER_FORM',
  ACCOUNT_DETAILS_FORM = 'ACCOUNT_DETAILS_FORM',
  ACCOUNT_SECURITY_FORM = 'ACCOUNT_SECURITY_FORM',
  ACCUMULATED_CREATE_ACCOUNT = 'ACCUMULATED_CREATE_ACCOUNT',
  ACTION_CREATE_FORM = 'ACTION_CREATE_FORM',
  ACTION_DETAILS_FORM = 'ACTION_DETAILS_FORM',
  ADD_LINK_FOR_ACTIVITY_FORM = 'ADD_LINK_FOR_ACTIVITY_FORM',
  API_CLIENT_CREATE_FORM = 'API_CLIENT_CREATE_FORM',
  API_CLIENT_UPDATE_FORM = 'API_CLIENT_UPDATE_FORM',
  BUSINESS_ACTIVITY_FORM = 'BUSINESS_ACTIVITY_FORM',
  CREATE_COMMENT_FORM = 'CREATE_COMMENT_FORM',
  CREATE_REVIEW_FORM = 'CREATE_REVIEW_FORM',
  CREATE_SUB_COMMENT_FORM = 'CREATE_SUB_COMMENT_FORM',
  CREATE_SUB_PLAN_FORM = 'CREATE_SUB_PLAN_FORM',
  DASHBOARD_SETTINGS_FORM = 'DASHBOARD_SETTINGS_FORM',
  DASHBOARD_WIDGET_SETTINGS_FORM = 'DASHBOARD_WIDGET_SETTINGS_FORM',
  EDIT_ACTIVITY_FORM = 'EDIT_ACTIVITY_FORM',
  EDIT_COMMENT_FORM = 'EDIT_COMMENT_FORM',
  ENTITY_VISIBILITY_SETTINGS_FORM = 'ENTITY_VISIBILITY_SETTINGS_FORM',
  FIELD_OPTION_EDIT_FORM = 'FIELD_OPTION_EDIT_FORM',
  GLOBAL_SEARCH_FORM = 'GLOBAL_SEARCH_FORM',
  GROUP_SECURITY_CREATE_FORM = 'GROUP_SECURITY_CREATE_FORM',
  HOME_PAGE_FILTER_FORM = 'HOME_PAGE_FILTER_FORM',
  INJURY_MASTER_REVOKE_FORM = 'INJURY_MASTER_REVOKE_FORM',
  INJURY_MASTER_SETTINGS_FORM = 'INJURY_MASTER_SETTINGS_FORM',
  KPI_CREATE_FORM = 'KPI_CREATE_FORM',
  KPI_DETAILS_FORM = 'KPI_DETAILS_FORM',
  KPI_RECURRENCE_FORM = 'KPI_RECURRENCE_FORM',
  KPI_RESULT_TARGETS_FORM = 'KPI_RESULT_TARGETS_FORM',
  KPI_SCALE_FORM = 'KPI_SCALE_FORM',
  KPI_SET_RESULT_ROW_FORM = 'KPI_SET_RESULT_ROW_FORM',
  LICENCE_FORM = 'LICENCE_FORM',
  LINKED_ITEM_COMMENT_FORM = 'LINKED_ITEM_COMMENT_FORM',
  METATAGS_SEARCH_FORM = 'METATAGS_SEARCH_FORM',
  NEW_USER_FORM = 'NEW_USER_FORM',
  OBJECTIVE_DETAILS_FORM = 'OBJECTIVE_DETAILS_FORM',
  OBJECT_DETAILS_FORM = 'OBJECT_DETAILS_FORM',
  OBJECT_REVIEW_QUESTIONS_FORM = 'OBJECT_REVIEW_QUESTIONS_FORM',
  OBJECT_SECURITY_CREATE_FORM = 'OBJECT_SECURITY_CREATE_FORM',
  OBJECT_SECURITY_FORM = 'OBJECT_SECURITY_FORM',
  PAGE_SEARCH_FORM = 'PAGE_SEARCH_FORM',
  PARENT_FIELDS_FORM = 'PARENT_FIELDS_FORM',
  PLAN_CLONE_FORM = 'PLAN_CLONE_FORM',
  PLAN_CREATE_FORM = 'PLAN_CREATE_FORM',
  PLAN_EDIT_FORM = 'PLAN_EDIT_FORM',
  PLAN_SETTINGS_FORM = 'PLAN_SETTINGS_FORM',
  PLAN_TYPE_CREATE_FORM = 'PLAN_TYPE_CREATE_FORM',
  PLAN_TYPE_EDIT_FORM = 'PLAN_TYPE_EDIT_FORM',
  PLAN_FILTER_FORM = 'PLAN_FILTER_FORM',
  PLAN_TYPES_FILTER_FORM = 'PLAN_TYPES_FILTER_FORM',
  PROFILE_CREATE_FORM = 'PROFILE_CREATE_FORM',
  PROPERTY_EDIT_FORM = 'PROPERTY_EDIT_FORM',
  REPORT_UPDATE_FORM = 'REPORT_UPDATE_FORM',
  REPORT_PERMISSIONS_FORM = 'REPORT_PERMISSIONS_FORM',
  RESET_PASSWORD_CONFIRM_FORM = 'RESET_PASSWORD_CONFIRM_FORM',
  RESET_PASSWORD_FORM = 'RESET_PASSWORD_FORM',
  RESOURCE_CREATE_FORM = 'RESOURCE_CREATE_FORM',
  REVIEW_DETAILS_FORM = 'REVIEW_DETAILS_FORM',
  RISK_FIELD_RECURRENCE_FORM = 'RISK_FIELD_RECURRENCE_FORM',
  RISK_MATRIX_APPETITE_FORM = 'RISK_MATRIX_APPETITE_FORM',
  RISK_RECURRENCE_FORM = 'RISK_RECURRENCE_FORM',
  RISK_TEMPLATE_FORM = 'RISK_TEMPLATE_FORM',
  RISK_TEMPLATE_FORM_ADD_FORM = 'RISK_TEMPLATE_FORM_ADD_FORM',
  RISK_VIEW_ADD_FILTER_FORM = 'RISK_VIEW_ADD_FILTER_FORM',
  RISK_VIEW_FORM = 'RISK_VIEW_FORM',
  RISK_VIEW_FILTER_FORM = 'RISK_VIEW_FILTER_FORM',
  SCALE_OPTION_DETAILS_FORM = 'SCALE_OPTION_DETAILS_FORM',
  SCHEDULED_RISK_RECURRENCE_FORM = 'SCHEDULED_RISK_RECURRENCE_FORM',
  SCHEDULE_REVIEW_EDIT_FORM = 'SCHEDULE_REVIEW_EDIT_FORM',
  SCHEDULE_REVIEW_FORM = 'SCHEDULE_REVIEW_FORM',
  SELECT_MULTI_VALUE_FORM = 'SELECT_MULTI_VALUE_FORM',
  SET_COLOR_FORM = 'SET_COLOR_FORM',
  SET_DOCUMENT_DESCRIPTION_FORM = 'SET_DOCUMENT_DESCRIPTION_FORM',
  SET_WORKING_HOURS_FORM = 'SET_WORKING_HOURS_FORM',
  SIGN_IN_FORM = 'SIGN_IN_FORM',
  SYSTEM_PROCESS_CREATE_FORM = 'SYSTEM_PROCESS_CREATE_FORM',
  SYNC_RULES_FORM = 'SYNC_RULES_FORM',
  LOOKUP_FILTER_FORM = 'LOOKUP_FILTER_FORM',
  TEMPLATE_SETTINGS_FORM = 'TEMPLATE_SETTINGS_FORM',
  USER_DETAILS_EDIT_FORM = 'USER_DETAILS_EDIT_FORM',
  USER_PASSWORD_EDIT_FORM = 'USER_PASSWORD_EDIT_FORM',
  TWO_FACTOR_VERIFY_FORM = 'TWO_FACTOR_VERIFY_FORM',
  TWO_FACTOR_CONFIRM_SETUP_FORM = 'TWO_FACTOR_CONFIRM_SETUP_FORM',
  TWO_FACTOR_DISABLE_FORM = 'TWO_FACTOR_DISABLE_FORM',
  TWO_FACTOR_REGENERATE_CODES_FORM = 'TWO_FACTOR_REGENERATE_CODES_FORM',
  TEXT_FIELD_FORM = 'TEXT_FIELD_FORM'
}

export const SELECT_GROUP_LABELS = {
  PLAN: 'PLANS',
  OBJECTIVE: 'OBJECTIVES',
  ACTION: 'ACTIONS',
  KPI: 'INDICATORS',
  FORM: 'FORMS',
  FIELDS: 'FIELDS',
  ANOTHER_FORM_FIELDS: 'ANOTHER FORM FIELDS',
  SOURCES: 'SOURCES',
  ANOTHER_FORM: 'ANOTHER FORMS',
  TEMPLATES: 'TEMPLATES',
  USERS_AND_POSITIONS: 'USERS AND POSITIONS',
  PLAN_TYPES: 'PLAN TYPES',
  ROLES: 'ROLES',
  PEOPLE: 'PEOPLE',
  POSITIONS: 'POSITIONS',
  LOCATIONS: 'LOCATIONS',
  BUSINESS_ACTIVITIES: 'BUSINESS_ACTIVITIES',
  BUSINESS_PROCESSES: 'BUSINESS_PROCESSES',
  BUSINESS_UNITS: 'BUSINESS_UNITS'
}
